
<template>
  <div class="flex justify-end text-14" :class="isDarkMode ? 'text-app-color' : 'text-dark-600'">
    <DropdownModule
      ref="dropdownRef"
      :width="180"
      button-classes="py-7 px-10"
      append-to-body
      remove-optional-top-gap
      :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
      position-menu="left"
      top-position="100%"
    >
      <template #button>
        <div class="flex items-center cursor-pointer">
          <div v-if="selectedMembers.length > 0" class="flex flex-wrap">
            <div
              v-for="member in selectedMembers"
              :key="member.id"
              class="flex items-center rounded-8 mr-5 min-w-50 font-semibold my-5"
            >
              <div class="text-app-color rounded-6 py-5 px-10"
                   :class="isDarkMode ? 'bg-book' : 'bg-white shadow-user-badge border border-grey-500'"
              >
                <UserBadge
                  :first-name="member.firstName"
                  :last-name="member.lastName"
                  :color="member.color"
                  color-height="h-18"
                />
              </div>
            </div>
          </div>

          <div
            v-else
            class="text-14 font-semibold flex items-center rounded-8 px-10 py-4 my-5 mr-5 border "
            :class="isDarkMode ? 'border-project' : 'border-grey-125'"
          >
            Mention member
          </div>
        </div>
      </template>

      <div class="max-h-300 overflow-y-auto">
        <div
          v-for="member in members"
          :key="member.id"
          class="hover:bg-selection group-scope last:rounded-b-10 first:rounded-t-10 text-app-color cursor-pointer"
        >
          <div class="text-app-color rounded-6 py-6 px-10" @click.stop="toggleMember(member)">
            <UserBadge
              :first-name="member.firstName"
              :last-name="member.lastName"
              :color="member.color"
              color-height="h-18"
            >
              <template #button>
                <i v-if="isSelected(member)" class="icon-check_mark text-18" />
              </template>
            </UserBadge>
          </div>
        </div>
      </div>
    </DropdownModule>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

import DropdownModule from '@/components/shared/form-controls/DropdownModule'
import UserBadge from '@/components/shared/UserBadge'

export default defineComponent({
  components: { DropdownModule, UserBadge },

  props: {
    selectedMembers: Array,
    members: Array
  },

  emits: ['toggleMember'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const show = ref(false)

    const isSelected = computed(() => member => props.selectedMembers.some(item => item.id === member.id))
    const isDarkMode = computed(() => getters.isDarkMode)

    function showDropdown () {
      show.value = true
    }

    function close () {
      show.value = false
    }

    function toggleMember (member) {
      const isSelected = props.selectedMembers.some(item => item.id === member.id)
      emit('toggleMember', { member, isSelected })
    }

    return {
      // data
      show,
      // computed
      isSelected,
      isDarkMode,
      // functions
      close,
      showDropdown,
      toggleMember
    }
  }
})
</script>
